import { cn } from "@/lib/utils";
import { extractTokenValue } from "@/utils/helpers/tokenUtils";

export interface ULThemeLogoProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * Optional image url of the logo.
   */
  imageUrl?: string;
  /**
   * Alt Text for the logo image
   */
  altText: string;
  /**
   * Optional Classes for custom overrides
   */
  className?: string;
}

const ULThemeLogo = ({
  imageUrl,
  altText,
  className,
  ...rest
}: ULThemeLogoProps) => {
  // Using extractTokenValue utility to extract the logo URL, Logo Visible flags from CSS variable
  const themedLogoSrcValue = extractTokenValue("--ul-theme-widget-logo-url");
  const isLogoHidden =
    extractTokenValue("--ul-theme-widget-logo-position") === "none";
  const themedStylesWrapper = "flex flex-wrap justify-widget-logo";
  // Brand logos vary in aspect ratio, unlike avatars — constrain by height only
  // and let width scale naturally, with object-contain guarding against stretch.
  const themedStylesImg =
    "h-(--height-widget-logo) w-auto object-contain rounded-none";
  const logoSrc = themedLogoSrcValue || imageUrl;

  return (
    !isLogoHidden && (
      <div className={cn(themedStylesWrapper, className)}>
        <img
          src={logoSrc}
          alt={altText}
          className={cn(themedStylesImg)}
          loading="eager" // Default should load an image immediately
          decoding="async" // Decode the image asynchronously
          fetchPriority="high" // Fetch the image at a high priority
          {...rest}
        />
      </div>
    )
  );
};
export default ULThemeLogo;
